export * from './IconRuler';
export { default as IconRuler } from './IconRuler';
